import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import AddCircleOutlineRounded from "@mui/icons-material/AddCircleOutlineRounded";

import Form from "./Form";
import graph from "./graph";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { FormattedMessage } from "react-intl";
import { isEmptyObject } from "helpers/formatObject";
import {
  NewDialog,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";

export default function CreatePopup({ title, refetch }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState(true);
  const { userToken } = useSelector((state) => state.auth);
  const [formCreate, { loading }] = useMutation(graph.create.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const onChange = ({ formData, errors }) => {
    setFormData(formData);
    setFormError(Boolean(errors.length > 0));
  };

  const onSubmit = async () => {
    try {
      const { title, details } = formData;
      const { data, errors } = await formCreate({
        context: {
          serviceName: graph.create.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          title,
          details,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.create.name]?.messages.map((message) =>
            toast.success(String(message))
          );
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  return (
    <>
      <Button
        size="medium"
        color="warning"
        onClick={onOpen}
        disabled={loading}
        sx={{ bgcolor: "action.hover" }}
        endIcon={<AddCircleOutlineRounded fontSize="small" />}
      >
        جدید
      </Button>
      <NewDialog label="create" open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper">
            <Form formData={formData} onChange={onChange} />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            size="large"
            color="primary"
            variant="contained"
            onClick={onSubmit}
            sx={{ minWidth: 80 }}
            disabled={loading || formError}
          >
            <FormattedMessage id="create" />
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
